import { Injectable } from "@angular/core";

import { GetPagedBody, HttpService, HttpServiceBaseCRUD, Lookup } from "src/app/core";

@Injectable({
  providedIn: "root",
})
export class MuseumBuildingService extends HttpService implements HttpServiceBaseCRUD {
  protected override get baseUrl(): string {
    return "museumbuildings/";
  }

  add(body: any) {
    return this.post<Lookup>({ APIName: "add", body, showAlert: true });
  }

  update(body: any) {
    return this.put<Lookup>({ APIName: "update", body, showAlert: true });
  }

  remove(id: string) {
    return this.delete<boolean>({ APIName: `deletesoft/${id}`, showAlert: true });
  }

  getById(id: string) {
    return this.get<any>({ APIName: `get/${id}` });
  }

  getPaged(body: GetPagedBody<Record<string, string | number | boolean>>) {
    return this.getPagedRequest<Lookup[]>({ APIName: "getpaged", body });
  }

  getAll() {
    return this.get<Lookup[]>({ APIName: "getall" });
  }

  getByTicketType(id: string) {
    return this.get<any>({ APIName: `getservicebuildings/${id}` });
  }

  getPricedBuildingPaged(body: GetPagedBody<Record<string, string | number | boolean>>) {
    return this.post<Lookup[]>({ APIName: "getpricedbuildingpaged", body });
  }
}
